import { Box } from '@hivebrite/design-system/Box';
import { Button, sizeByKeyname } from '@hivebrite/design-system/Button';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';

interface AISummaryButtonProps {
  isLoading: boolean;
  label: string;
  loadingText: string;
  onClick: () => void;
}

export const AISummaryButton = ({
  isLoading,
  label,
  onClick,
  loadingText,
}: AISummaryButtonProps) => {
  if (isLoading) {
    return (
      <Box
        color="primary"
        px={3}
        minHeight={sizeByKeyname.normal}
        fontWeight={600}
        fontSize="14px"
        alignItems="center"
        justifyContent="center"
      >
        <Box mr={2}>
          <FontAwesomeIcon
            animation="fade"
            height="16px"
            iconName="sparkles"
            iconType={CATEGORIES.SOLID}
            color="primary"
          />
        </Box>
        {loadingText}
      </Box>
    );
  }

  return (
    <Button
      icon={() => (
        <FontAwesomeIcon
          height="16px"
          iconName="sparkles"
          iconType={CATEGORIES.SOLID}
        />
      )}
      onClick={onClick}
      variant="inversed"
    >
      {label}
    </Button>
  );
};
